import { DesignSize, CartItemDesignInstance } from "../models/CartItem";
import { DesignInstanceViewModelProps } from "./DesignInstance.Component";
import { Design } from "../../../../core/models/entities/Design";

interface Props {
  index: number;
  instance: CartItemDesignInstance;
  design: Design;
  updateInstance: (index: number, instances: CartItemDesignInstance) => void;
}

export function DesignInstanceVM({
  index: instanceIndex,
  instance,
  design,
  updateInstance,
}: Props): DesignInstanceViewModelProps {
  function updateLabel(value: string) {
    updateInstance(instanceIndex, {
      ...instance,
      label: value,
    });
  }

  function updateInstanceSize(designSize: string) {
    updateInstance(instanceIndex, {
      ...instance,
      size: designSize,
    });
  }

  function updateInstanceQuantity(quantity: number) {
    updateInstance(instanceIndex, {
      ...instance,
      toDelivery: quantity,
    });
  }

  function handleLogoText(logoIndex: number, value: string | number): void {
    const logos = instance.logos.map((logo, currentIndex) =>
      currentIndex === logoIndex ? { ...logo, value: value } : logo
    );
    updateInstance(instanceIndex, {
      ...instance,
      logos: logos,
    });
  }

  return {
    designInstance: instance,
    design: design,
    index: instanceIndex,
    updateLabel: updateLabel,
    handleInstanceSizeChange: updateInstanceSize,
    handleInstanceQuantity: updateInstanceQuantity,
    handleLogoText: handleLogoText,
  };
}
